import type { MiddlewareContext, Middleware } from '@/types/router';
import type { NavigationGuardNext } from 'vue-router';

function middlewarePipeline(
    context: MiddlewareContext,
    middleware: Middleware[],
    index: number
): NavigationGuardNext {
    const nextMiddleware = middleware[index];

    if (!nextMiddleware) {
        return context.next;
    }

    const nextFn = ((arg?: unknown) => {
        if (arg !== undefined) {
            return context.next(arg as never);
        }

        const nextPipeline = middlewarePipeline(context, middleware, index + 1);

        nextMiddleware({
            ...context,
            next: nextPipeline
        });
    }) as NavigationGuardNext;

    return nextFn;
}

export default middlewarePipeline;
